// src/firestore/users/fragments/index.ts

import * as users from '..'
import * as path from '../../path'
import { firestore } from '../../../helpers/firebase/firestore'
import { RarityType } from '../../cards'

/**
 * Path to the `fragments` collection under a user.
 *
 * `users/{userId}/fragments`
 */
export function collectionPath(userId: string): string {
  return path.append(users.documentPath(userId), 'fragments')
}

/**
 * Path to a specific fragment document.
 *
 * `users/{userId}/fragments/{cardId}`
 */
export function documentPath(userId: string, cardId: string): string {
  return path.append(collectionPath(userId), cardId)
}

/**
 * A Firestore document representing a user's fragments for a specific card.
 */
export type Fragment = {
  /** Reference to the card definition (cardId from `cards` collection) */
  cardId: string
  /** name (duplicate from cards for easier querying) of the userCard */
  name: string
  /** url (duplicate from cards for easier querying) of the userCard */
  url: string
  /** Category (duplicate from cards for easier querying) have to be consistency with Cards info */
  category: string
  /** Collection name (duplicate from cards for easier querying) have to be consistency with Cards info*/
  collection: string
  /** Subcollection name (duplicate from cards for easier querying) have to be consistency with Cards info*/
  subcollection: string
  /** Rarity (duplicate from cards for easier querying) have to be consistency with Cards info */
  rarity: RarityType
  /** Number of fragments the user has for this card */
  fragmentCount: number
  /** Timestamp when the fragment count was last updated */
  lastUpdatedAt: firestore.Timestamp
}
